import type { ReactElement } from 'react';

export type OpenMindedPillarGlyph = 'optional' | 'orbit' | 'people' | 'heart' | 'fluid' | 'prompts';

const GLYPHS: Record<OpenMindedPillarGlyph, () => ReactElement> = {
  optional: () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="7.5" stroke="currentColor" strokeWidth="1.75" />
      <path d="M12 8v8M8 12h8" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  ),
  orbit: () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="7.5" stroke="currentColor" strokeWidth="1.5" opacity="0.45" />
      <circle cx="12" cy="12" r="4.75" stroke="currentColor" strokeWidth="1.5" opacity="0.7" />
      <circle cx="12" cy="12" r="2" fill="currentColor" />
    </svg>
  ),
  people: () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="9" cy="9" r="3" stroke="currentColor" strokeWidth="1.75" />
      <path
        d="M4.5 18.5c.8-2.4 2.4-3.5 4.5-3.5s3.7 1.1 4.5 3.5"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <circle cx="16.5" cy="10" r="2.25" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M14 18c.5-1.6 1.6-2.5 3-2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  heart: () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M12 20.5s-6.5-4.2-6.5-9.2C5.5 8.4 7.6 6.5 10 6.5c1.4 0 2 .8 2 .8s.6-.8 2-.8c2.4 0 4.5 1.9 4.5 4.8 0 5-6.5 9.2-6.5 9.2Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
    </svg>
  ),
  fluid: () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M4 14c2.5-3 5-3 8 0s5.5 3 8 0"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M4 10c2.5-3 5-3 8 0s5.5 3 8 0"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        opacity="0.65"
      />
    </svg>
  ),
  prompts: () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M8 6h8M8 10h6M8 14h7"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M6 5c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v12l-3-2H8c-1.1 0-2-.9-2-2V5Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

export function OpenMindedPillarIcon({ kind }: { kind: OpenMindedPillarGlyph }) {
  const Icon = GLYPHS[kind];
  return <Icon />;
}
